import styled from 'styled-components';

const StyledErrorPage = styled.div`
	display: grid;
	place-items: center;
	margin: 100px 0;
	gap: 2em;
	text-align: left;
`;

const StyledErrorText = styled.div`
	padding: 0 1em;
	width: 32em;
	max-width: 100vw;
`;

const ErrorPage = () => {
	return (
		<StyledErrorPage>
			<StyledErrorText>
				<p>Site currently not available</p>
				<p>Our site is currently offline due to maintenance activities.</p>
				<p>Please, check this site again later.</p>
			</StyledErrorText>
			<StyledErrorText>
				<p>Site actuellement indisponible</p>
				<p>Notre site est actuellement hors ligne en raison d&apos;activités de maintenance.</p>
				<p>Veuillez consulter à nouveau ce site plus tard.</p>
			</StyledErrorText>
			<StyledErrorText>
				<p>Seite vorübergehend nicht erreichbar</p>
				<p>Aufgrund von Wartungsarbeiten ist diese Seite leider vorübergehend nicht erreichbar.</p>
				<p>Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.</p>
			</StyledErrorText>
			<StyledErrorText>
				<p>©{new Date().getFullYear()} AUDI AG. All rights reserved.</p>
			</StyledErrorText>
		</StyledErrorPage>
	);
};

export default ErrorPage;
